import fp from 'lodash/fp';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { apiActions as userApiActions } from '../../user/actions';
import { API_ENDPOINT } from './endpoints';
import { apiAction as get } from './get';

const action = createActions({
  CPD_POINTS: {
    ADD: (contentId) => ({ contentId }),
    API: {
      ADD: apiResourceActionCreator('cpdPoint')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(API_ENDPOINT, authToken, payload, action.cpdPoints.api.add)

function* add({ payload }) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, payload));

  const result = yield apiActionResult(action.cpdPoints.api.add);

  if (result.success) {
    yield put(userApiActions.user.getCpdCategory(authToken));
    yield put(get(authToken, { skip: 0, take: 6 }));
  }
}

const configuration = {
  name: 'add',
  action: action,
  sagas: add,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false,
      cpdPoints: fp.concat(state.cpdPoints, [action.payload.cpdPoint.userCpdPoint]),
      relatedTasks: action.payload.cpdPoint.tasks
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/cpd-points/configurations/add.js